import { authService } from 'app/api/service/auth-service';
import { AuthToken } from 'app/api/model/AuthToken';

class TokenService {
    public static getAccessToken(code: string, codeVerifier: string): Promise<AuthToken> {
        return authService.fetchAccessToken(code, codeVerifier);
    }
}

export { TokenService };
